import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { SalesChannelResponse } from '../dtos/responses/salles-channel.model';
import { map } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SellerService {
  private http: HttpClient;

  constructor() {
    this.http = inject(HttpClient);
  }

  suggest(search: string) {
    const params = { search };
    const resource = `${environment.gateway.url}/backoffice/v2/sales-channels/suggestions`;
    return this.http.get<SalesChannelResponse[]>(resource, { params }).pipe(map((res) => res.map((i) => ({ ...i, id: i.id.toString() }))));
  }
}
